import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../RootState";
import { DeleteAnalogReportResponse, GetAnalogGalleriesResponse, GetAnalogInventoryProcessListResponse, GetAnalogReportResponse, PostAnalogGalleriesResponse, PostAnalogRequest, PostAnalogResponse } from "./state";
import * as API from "./api";


type PayloadRequest = { page?: number }
export const getAnalogInventoryProcessList = createAsyncThunk<GetAnalogInventoryProcessListResponse/** RESPONSE TYPE */,
    PayloadRequest,
    {
        state: RootState;
    }
>('analoginventory/getProcessList', async ({ page }: PayloadRequest, thunkAPI) => {
    page = page ?? 1;
    const store: RootState = thunkAPI.getState();
    const { token } = store.User;

    return API.getAnalogProcesses(token, page);
});

export const postAnalog = createAsyncThunk<PostAnalogResponse, { data: PostAnalogRequest }, { state: RootState }>(
    'analoginventory/postAnalog',
    async ({ data }, thunkAPI) => {
        const store: RootState = thunkAPI.getState();
        const { token } = store.User;
        try {

            const response = await API.postAnalog(token, data);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue('Error al realizar la solicitud');
        }
    }
);

export const getAnalogGalleries = createAsyncThunk<GetAnalogGalleriesResponse, void, { state: RootState }>(
    'analoginventory/getAnalogGalleries',
    async (_: void, thunkAPI) => {
        const store: RootState = thunkAPI.getState();
        const { token } = store.User;
        try {
            const response = await API.getAnalogGalleries(token);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue('Error al obtener las galerías');
        }
    }
);

export const postAnalogGalleries = createAsyncThunk<PostAnalogGalleriesResponse, { image: File, name: string }, { state: RootState }>(
    'analoginventory/postAnalogGalleries',
    async ({ image, name }, thunkAPI) => {
        const store: RootState = thunkAPI.getState();
        const { token } = store.User;
        try {
            const response = await API.postAnalogGalleries(token, image, name);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue('Error al cargar la imagen a la galería');
        }
    }
);

export const getAnalogReport = createAsyncThunk<GetAnalogReportResponse, { id: string }, { state: RootState }>(
    'analoginventory/getAnalogReport',
    async ({ id }, thunkAPI) => {
        const store: RootState = thunkAPI.getState();
        const { token } = store.User;
        try {
            const response = await API.getAnalogReport(token, id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue('Error al obtener el informe');
        }
    }
);

export const deleteAnalogReport = createAsyncThunk<DeleteAnalogReportResponse, { id: string }, { state: RootState }>(
    'analoginventory/deleteAnalogReport',
    async ({ id }, thunkAPI) => {
        const store: RootState = thunkAPI.getState();
        const { token } = store.User;
        try {
            const response = await API.deleteAnalogReport(token, id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue('Error al eliminar el informe');
        }
    }
);
